var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-charts',{ref:"echarts",style:(_vm.styleObj),attrs:{"options":_vm.option,"autoresize":""},on:{"click":_vm.echartClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }